export const BCP47_LANGUAGE_TAG_REGEXP: RegExp = /([a-z]{2})(-([A-Z]{2}))?/;

/**
 * Resolves the language subtag from the passed-in BCP47 language tag.
 *
 * @param languageTag - The BCP47 tag which includes the language subtag.
 *
 * @example
 *   input: 'pl-PL'
 *   output: 'pl'
 *
 * @example
 *   input: 'en'
 *   output: 'en'
 *
 * @throws {Error} - if the passed-in argument is not a valid BCP47 language tag.
 */
export const getLanguageSubtagFromBCP47LanguageTag = (languageTag: string): string => {
  if (!isValidBCP47LanguageTag(languageTag)) {
    throw new Error(`Provided string [${languageTag}] is NOT a valid region string!`);
  }

  return languageTag.match(BCP47_LANGUAGE_TAG_REGEXP)![1];
};

/**
 * Determines whether the passed-in string represents the valid BCP47 language tag.
 *
 * @param subject - The string to validate.
 *
 * @example
 *   input: 'pl-PL'
 *   output: true
 *
 * @example
 *   input: 'en' // missing region part
 *   output: false
 *
 * @example
 *   input: 'EN-GB' // first 2 letters in uppercase
 *   output: false
 *
 * @throws {Error} - if the passed-in argument is not a string.
 */
export const isValidBCP47LanguageTag = (subject: string): boolean => {
  if (typeof subject !== 'string') {
    throw new Error(`Expected [subject] to be a type of [string], bot got [${typeof subject}]!`);
  }

  return BCP47_LANGUAGE_TAG_REGEXP.test(subject);
};
